<div class="modal-header" mat-dialog-title>
  <div class="modal-header-icon"><mat-icon class="material-symbols-outlined">send</mat-icon></div>
  <div class="modal-header-titles">
    <h2 class="modal-title">Lote de notas fiscais eletrônicas</h2>
    <span class="modal-subtitle">{{ subtitulo }}</span>
  </div>
  @if (etapa !== etapaEnum.Enviando) {
  <div class="modal-header-close-btn-container">
    <button mat-icon-button type="button" class="modal-close-btn icon-mat-symbols-btn" (click)="fechar()" aria-label="Fechar">
      <mat-icon class="material-symbols-outlined">close</mat-icon>
    </button>
  </div>
  }
</div>

@switch (etapa) {
@case (etapaEnum.Inicio) {
<mat-dialog-content class="modal-content">
  @if (isHomologacao) {
  <app-alert-card type="warning" icon="science" title="Ambiente de homologação">
    As notas são transmitidas em homologação: servem para testes e não têm valor fiscal.
  </app-alert-card>
  }

  @if (isCarregandoCertificado) {
  <app-loading-box height="56" width="100%" marginTop="0"></app-loading-box>
  } @else if (statusCertificado === statusCertificadoEnum.Valido) {
  <app-alert-card type="success" icon="verified" title="Certificado digital válido">
    @if (dataVencimentoCertificado) {
    O certificado A1 da empresa vale até {{ dataVencimentoCertificado | date: 'dd/MM/yyyy' }}.
    } @else {
    O certificado A1 da empresa está válido.
    }
  </app-alert-card>
  } @else if (isCertificadoComAviso) {
  <app-alert-card type="warning" icon="warning" title="Certificado digital perto do vencimento">
    O certificado A1 da empresa vence em {{ dataVencimentoCertificado | date: 'dd/MM/yyyy' }}. Renove para não interromper a emissão.
  </app-alert-card>
  } @else if (statusCertificado === statusCertificadoEnum.Vencido) {
  <app-alert-card type="error" icon="error" title="Certificado digital vencido">
    O certificado A1 da empresa venceu em {{ dataVencimentoCertificado | date: 'dd/MM/yyyy' }}. A SEFAZ não autoriza as notas até a
    renovação do certificado em Configurações de notas fiscais.
  </app-alert-card>
  } @else if (statusCertificado === statusCertificadoEnum.NaoConfigurado) {
  <app-alert-card type="error" icon="error" title="Certificado digital não cadastrado">
    A empresa não tem certificado A1 cadastrado. A SEFAZ não autoriza as notas sem ele; cadastre o certificado em Configurações de
    notas fiscais.
  </app-alert-card>
  }

  <div class="sub-section-title">Notas do lote</div>
  <div class="opcoes-lote">
    <mat-checkbox [checked]="true" [disabled]="true">Aguardando transmissão</mat-checkbox>
    <mat-checkbox [checked]="isIncluirRejeitadas" [disabled]="isPreparando" (change)="alternarRejeitadas($event.checked)">
      Incluir rejeitadas
    </mat-checkbox>
  </div>
  <p class="info-text">
    Entram as notas emitidas nos últimos 30 dias. Cada nota é enviada sozinha para a SEFAZ e o resultado aparece na listagem.
  </p>

  @if (isPreparando) {
  <app-loading-box height="72" width="100%" marginTop="8"></app-loading-box>
  } @else if (quantidade > 0) {
  <div class="resumo-lote">
    <span class="resumo-lote-quantidade">{{ quantidade === 1 ? '1 nota' : quantidade + ' notas' }}</span>
    <span class="resumo-lote-valor">{{ lote?.valorTotal | abnt:'preco':2 }}</span>
  </div>
  } @else {
  <app-empty-state icon="inbox" title="Nada para enviar"
    subtitle="Nenhuma nota aguardando transmissão ou rejeitada foi emitida nos últimos 30 dias."></app-empty-state>
  }

  @if (!isPreparando && lote?.listaNaoElegivel?.length) {
  <div class="sub-section-title">Fora do lote</div>
  <ul class="lista-notas">
    @for (nota of lote?.listaNaoElegivel ?? []; track nota.idNFeSaida) {
    <li><strong>{{ rotuloNota(nota.numero) }}:</strong> {{ nota.motivo }}</li>
    }
  </ul>
  }
</mat-dialog-content>

<mat-dialog-actions align="end" class="modal-footer">
  <button mat-stroked-button type="button" class="btn-secondary" (click)="fechar()">Cancelar</button>
  <button mat-flat-button type="button" class="btn-primary" [disabled]="isPreparando || quantidade === 0" (click)="enviar()">
    <mat-icon class="material-symbols-outlined">send</mat-icon>
    Transmitir
  </button>
</mat-dialog-actions>
}

@case (etapaEnum.Enviando) {
<mat-dialog-content class="modal-content enviando-content">
  <p class="enviando-posicao">Nota {{ posicaoEnvio }}/{{ totalEnvio }}</p>
  <mat-progress-bar mode="determinate" [value]="percentualEnvio"></mat-progress-bar>
  @if (isInterrompido) {
  <p class="info-text">O envio será interrompido depois da nota atual.</p>
  }
</mat-dialog-content>

<mat-dialog-actions align="end" class="modal-footer">
  <button mat-stroked-button type="button" class="btn-secondary" [disabled]="isInterrompido" (click)="interromper()">
    <mat-icon class="material-symbols-outlined">stop_circle</mat-icon>
    Interromper
  </button>
</mat-dialog-actions>
}

@case (etapaEnum.Resultado) {
<mat-dialog-content class="modal-content">
  <mat-tab-group [selectedIndex]="0" animationDuration="0ms">
    <mat-tab label="Não enviadas ({{ naoEnviadas.length }})">
      @if (naoEnviadas.length) {
      <ul class="lista-notas lista-notas-resultado">
        @for (nota of naoEnviadas; track nota.idNFeSaida) {
        <li class="nota-nao-enviada">
          <div class="nota-nao-enviada-texto">
            <strong>{{ rotuloNota(nota.numero) }}</strong>
            @for (motivo of nota.motivos; track $index) {
            <span class="nota-motivo">{{ motivo }}</span>
            }
          </div>
          <button mat-stroked-button type="button" class="btn-section" (click)="corrigir(nota)">
            <mat-icon class="material-symbols-outlined">edit</mat-icon>
            Corrigir
          </button>
        </li>
        }
      </ul>
      } @else {
      <app-empty-state icon="task_alt" title="Todas as notas foram enviadas"></app-empty-state>
      }
    </mat-tab>
    <mat-tab label="Enviadas para transmissão ({{ enviadas.length }})">
      @if (enviadas.length) {
      <p class="info-text">O resultado da SEFAZ aparece na listagem em instantes.</p>
      <ul class="lista-notas lista-notas-resultado">
        @for (nota of enviadas; track nota.idNFeSaida) {
        <li>{{ rotuloNota(nota.numero) }} - {{ nota.valorTotal | abnt:'preco':2 }}</li>
        }
      </ul>
      } @else {
      <app-empty-state icon="inbox" title="Nenhuma nota enviada"></app-empty-state>
      }
    </mat-tab>
  </mat-tab-group>
</mat-dialog-content>

<mat-dialog-actions align="end" class="modal-footer">
  <button mat-flat-button type="button" class="btn-primary" (click)="fechar()">Fechar</button>
</mat-dialog-actions>
}
}
